module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header-bio"
  }, [_c('div', {
    staticClass: "inner-header-up"
  }, [_c('div', {
    staticClass: "dropdown inner-header-up-group",
    class: {
      none: !_vm.logged
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu default-font-size"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/biomanager/"
    }
  }, [_c('a', {
    staticClass: "dropdown-item"
  }, [_vm._v("Home")])])], 1), _vm._v(" "), (_vm.check('USERS')) ? _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/biomanager/users"
    }
  }, [_c('a', {
    staticClass: "dropdown-item"
  }, [_vm._v("Usuários")])])], 1) : _vm._e(), _vm._v(" "), (_vm.check('AGENTSUPT')) ? _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/biomanager/agentsupdate"
    }
  }, [_c('a', {
    staticClass: "dropdown-item"
  }, [_vm._v("Atualização de Agentes")])])], 1) : _vm._e(), _vm._v(" "), (_vm.check('BIO')) ? _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/biomanager/managepsbio"
    }
  }, [_c('a', {
    staticClass: "dropdown-item"
  }, [_vm._v("Consulta Biométrica Griaule")])])], 1) : _vm._e(), _vm._v(" "), (_vm.check('BIO')) ? _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/biomanager/consultaspid"
    }
  }, [_c('a', {
    staticClass: "dropdown-item"
  }, [_vm._v("Consulta Biométrica SPID")])])], 1) : _vm._e(), _vm._v(" "), (_vm.check('BIO')) ? _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/biomanager/findpsbioorigin"
    }
  }, [_c('a', {
    staticClass: "dropdown-item"
  }, [_vm._v("Consulta Origem IDN")])])], 1) : _vm._e(), _vm._v(" "), (_vm.check('EXCBIO')) ? _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/biomanager/delete"
    }
  }, [_c('a', {
    staticClass: "dropdown-item"
  }, [_vm._v("Exclusão Biométrica")])])], 1) : _vm._e(), _vm._v(" "), (_vm.check('AUDIT')) ? _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/biomanager/subjectaudit"
    }
  }, [_c('a', {
    staticClass: "dropdown-item"
  }, [_vm._v("Auditoria de Sujeitos")])])], 1) : _vm._e(), _vm._v(" "), (_vm.check('FRAUD')) ? _c('li', [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/biomanager/fraud"
    }
  }, [_c('a', {
    staticClass: "dropdown-item"
  }, [_vm._v("Análise de Fraude")])])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "inner-header-up-content"
  }, [_c('img', {
    staticClass: "logo-certisign",
    attrs: {
      "src": require("../../../static/img/logo_certisign_24_white.png"),
      "alt": "Logo Certisign"
    }
  }), _vm._v(" "), (_vm.logged) ? _c('div', {
    staticClass: "user-info-box"
  }, [_c('div', {
    staticClass: "user-info-group"
  }, [_c('img', {
    staticClass: "user-frame",
    attrs: {
      "src": _vm.imagePath,
      "alt": "Foto de perfil do usuário"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-info-text"
  }, [_c('span', [_vm._v("Olá,")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.demo.displayName))])])]), _vm._v(" "), _c('a', {
    staticClass: "user-info-exit",
    on: {
      "click": _vm.logout
    }
  }, [_c('img', {
    staticClass: "logo-certisign",
    attrs: {
      "src": require("../../../static/img/sign-out.svg"),
      "alt": "ícone que indica saída do biomanager"
    }
  }), _vm._v(" "), _vm._m(1)])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-secondary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/list.svg"),
      "alt": "ícone de um menu com 3 barras horizontais"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-info-text"
  }, [_c('span', [_vm._v("Sair")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-690981e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/components/Header.vue
// module id = 259
// module chunks = 0